import { useContext, useEffect, useMemo, useState } from "react";
import { Auth } from "../../StateManagment/Auth.js";
import { useTaskDTO } from "../../hooks/firebase/TaskDto.jsx";
import { CalendarView } from "../../components/calendar/CalendarView.jsx";
import { personaColorById } from "../../helpers/calendar/personaAgendaColors.js";
import { client } from "../../hooks/Client.js";
import { useFirestore, useFirestorePersonaAbsences } from "../../firebase/useFirestore.js";
import useAgendaSchedule from "../../hooks/calendar/useAgendaSchedule.js";

const MOBILE_HEADER_TOOLBAR = {
  left: 'prev,next today',
  center: 'title',
  right: 'listWeek,timeGridWeek,timeGridDay',
};

const MobileCalendarFull = () => {
  const [auth] = useContext(Auth);
  const taskDTO = useTaskDTO();

  const [docs, setDocs] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);

  const [dateRange, setDateRange] = useState({
    start: new Date(),
    end: new Date(),
  });

  // Zelfde regel als de agenda op de computer (useAgendaData): het rooster van
  // actieve deelnemers, plus dat van uitgestroomden met een datum, tot en met
  // die dag. Afwezigheid en kleur gelden voor precies die groep, anders kan een
  // getoond roosterblok nooit als afwezig gemarkeerd worden.
  const personas = useFirestore('Personas');
  const { visibleDocs, schedulePersonas, schedulePersonaIds, scheduleEndByPersonaId } =
    useAgendaSchedule(personas, docs, dateRange.start);
  const personaAbsences = useFirestorePersonaAbsences(schedulePersonaIds, client);
  const personaColors = useMemo(
    () => personaColorById(schedulePersonas),
    [schedulePersonas]
  );


  useEffect(() => {
    const unsubscribe = taskDTO.queryBy({
      query: (q) => {
        // "Complete agenda": alles (maar wel binnen company)
        return q.where("CompagnyID", "==", client);
      },
      dateStart: dateRange.start,
      dateEnd: dateRange.end,
      onUpdate: setDocs,
    });

    return () => unsubscribe?.();
  }, [dateRange, refreshCounter]); // eslint-disable-line

  return (
    <div className="mobile-page">
      <CalendarView
        docs={visibleDocs}
        userId={auth?.ID || null}
        onDateRangeChange={setDateRange}
        onStaleData={() => setRefreshCounter((c) => c + 1)}
        contextTitle={"Complete agenda"}
        contextId={null}
        contextType={null}
        initialview="listWeek"
        headerToolbar={MOBILE_HEADER_TOOLBAR}
        personaAbsences={personaAbsences}
        personaColorById={personaColors}
        scheduleEndByPersonaId={scheduleEndByPersonaId}
      />
    </div>
  );
};

export default MobileCalendarFull;
